import { Email, Phone } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { YesNoTag } from "@msuite/ui/tag";
import { createdAtFormatter } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import type { OrganizationMember } from "@msuite/utils/types";

const columnHelper = createColumnHelper<OrganizationMember>();

export const columns = [
	columnHelper.accessor("user.firstName", {
		header: localized("profile.first_name"),
		id: "firstName",
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("user.lastName", {
		header: localized("profile.last_name"),
		id: "lastName",
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("user.initials", {
		header: localized("profile.initials"),
		id: "initials",
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("user.email", {
		header: localized("personnel.fields.email"),
		id: "email",
		cell: (cell) => <Email>{guardString(cell.getValue())}</Email>,
	}),
	columnHelper.accessor("user.phone", {
		header: localized("personnel.fields.phone"),
		id: "phone",
		cell: (cell) => <Phone>{guardString(cell.getValue())}</Phone>,
	}),
	columnHelper.accessor("user.emailVerified", {
		header: localized("profile.email_verified"),
		id: "emailVerified",
		cell: (cell) => <YesNoTag value={cell.getValue()} />,
	}),
	columnHelper.accessor((row) => createdAtFormatter(row.membership), {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		cell: (cell) => cell.getValue(),
	}),
];
